import { render, staticRenderFns } from "./HomeCy.vue?vue&type=template&id=60472f84&scoped=true&"
import script from "./HomeCy.vue?vue&type=script&lang=js&"
export * from "./HomeCy.vue?vue&type=script&lang=js&"
import style0 from "./HomeCy.vue?vue&type=style&index=0&id=60472f84&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60472f84",
  null
  
)

export default component.exports